interface LogoProps {
  variant?: 'default' | 'compact' | 'icon-only';
  className?: string;
}

interface IsotipoProps {
  className?: string;
}

/**
 * Isotipo de marca AlertAI (identidad 04D): «A» con franja. Polígonos directos
 * (sin <use> ni id) para no chocar ids si se renderiza varias veces.
 */
export function Isotipo({ className = '' }: IsotipoProps) {
  return (
    <svg
      viewBox="0 0 100 100"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <polygon points="52,12 74,4 100,96 78,96" className="fill-brand-navy" />
      <polygon points="52,12 70,16 24,96 4,96" className="fill-brand-navy" />
      <polygon points="0,52 62,52 62,58 0,58" className="logo-papel" />
      <polygon points="0,72 62,72 62,78 0,78" className="logo-papel" />
      <polygon points="28,58 62,58 54.7,72 20.7,72" fill="#2672EC" />
    </svg>
  );
}

/** Wordmark: «Alert» navy + «AI» azul de marca. */
function Wordmark({ className }: { className: string }) {
  return (
    <span className={`font-bold tracking-tight text-brand-navy ${className}`}>
      Alert<span className="text-brand-blue">AI</span>
    </span>
  );
}

export default function Logo({ variant = 'default', className = '' }: LogoProps) {
  if (variant === 'icon-only') {
    return (
      <div role="img" aria-label="AlertAI" className={className}>
        <Isotipo className="w-10 h-10" />
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div role="img" aria-label="AlertAI" className={`flex items-center gap-2 ${className}`}>
        <Isotipo className="w-[26px] h-[26px] shrink-0" />
        <Wordmark className="text-[17px] leading-none" />
      </div>
    );
  }

  return (
    <div role="img" aria-label="AlertAI" className={`flex items-center gap-3 ${className}`}>
      <Isotipo className="w-10 h-10 shrink-0" />
      <div>
        <Wordmark className="block text-2xl leading-tight" />
        <p className="text-xs text-slate-500">Asistente tributario</p>
      </div>
    </div>
  );
}
